module.exports = __webpack_public_path__ + "static/media/1-audio.df91628.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/1-audio.wav
// module id = GSWt
// module chunks = 0